import { queryOptions, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { SchoolSettings } from './types'

export const schoolQuery = () =>
  queryOptions({ queryKey: ['school'], queryFn: () => api.get<SchoolSettings>('/school') })

export type SchoolPayload = Omit<
  SchoolSettings,
  'id' | 'logoUrl' | 'updatedAt' | 'vocabulary' | 'vocabularyOverrides'
> & {
  logoFileId: number | null
  /** term → word; "" follows the type's default */
  vocabulary: Record<'learner' | 'year' | 'class' | 'section', string>
}

export function useUpdateSchool() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: SchoolPayload) => api.put<SchoolSettings>('/school', payload),
    onSuccess: (school) => {
      qc.setQueryData(['school'], school)
      void qc.invalidateQueries({ queryKey: ['branding'] })
    },
  })
}
